export const defaultPaginationData = {
  totalCount: null,
  currentPage: 0, // MUI DataGrid page starts at 0. v4 documentation states it is 1, but that is incorrect. v5 has it correctly documented at 0.
  pageSize: 25,
};
